import { render, staticRenderFns } from "./PkChannelConfigExcelDialog.vue?vue&type=template&id=655a6a35&scoped=true&"
import script from "./PkChannelConfigExcelDialog.vue?vue&type=script&lang=js&"
export * from "./PkChannelConfigExcelDialog.vue?vue&type=script&lang=js&"
import style0 from "./PkChannelConfigExcelDialog.vue?vue&type=style&index=0&id=655a6a35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655a6a35",
  null
  
)

export default component.exports